export default "__VITE_ASSET__BZN6mMgb__"